import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Modal, Radio } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import AnalyticsActions from '@Actions/application/analyticsActions';
import './style.scss';

function MultiDocumentDownload({
  downloadLink, isModalOpen, toggleModal, downloadDocument, documentType, documentNumber,
}) {
  const [numberOfCopies, setNumberOfCopies] = useState(1);

  return (
    <Modal
      title="Number of Copies"
      onOk={() => toggleModal()}
      onCancel={() => toggleModal()}
      footer={[
        <Button key="cancel" onClick={() => toggleModal()}>
          Cancel
        </Button>,
        <Button
          key="print"
          type="primary"
          onClick={() => {
            downloadDocument({
              url: `${downloadLink}&copies=${numberOfCopies}`,
              document_type: documentType,
              document_number: documentNumber,
              key: uuidv4(),
            });
            toggleModal()
            setNumberOfCopies(1);
          }}
        >
          Print
        </Button>,
      ]}
      open={isModalOpen}
    >
      <Radio.Group onChange={(event) => setNumberOfCopies(event.target.value)} value={numberOfCopies}>
        <div className="multi-document-download__option">
          <Radio value={1}>
            <div className="font-weight-600">One Copy</div>
            <span>An original copy will be printed.</span>
          </Radio>
        </div>
        <div className="multi-document-download__option">
          <Radio value={2}>
            <div className="font-weight-600">Two Copies</div>
            <span>A supplier copy and a recipient copy will be printed.</span>
          </Radio>
        </div>
        <div className="multi-document-download__option">
          <Radio value={3}>
            <div className="font-weight-600">Three Copies</div>
            <span>A supplier copy, a transporter copy, and a recipient copy will be printed.</span>
          </Radio>
        </div>
        <div className="multi-document-download__option">
          <Radio value={4}>
            <div className="font-weight-600">Four Copies</div>
            <span>One additional copy will be printed along with original, duplicate, and triplicate copies.</span>
          </Radio>
        </div>
      </Radio.Group>
    </Modal>
  );
}

const mapStateToProps = ({

}) => ({

});

const mapDispatchToProps = (dispatch) => ({
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
});

MultiDocumentDownload.propTypes = {

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MultiDocumentDownload));
